export default {
  formatDate: function formatDate(dateTime, fmt) {
    fmt = fmt || "yyyy-MM-dd hh:mm:ss";

    if (!dateTime) {
      return dateTime;
    }
    if (_.isString(dateTime)) {
      dateTime = this.parseDate(dateTime);
    }

    if (!_.isDate(dateTime)) {
      return dateTime;
    }

    var o = {
      "M+": dateTime.getMonth() + 1,
      "d+": dateTime.getDate(),
      "h+": dateTime.getHours(),
      "m+": dateTime.getMinutes(),
      "s+": dateTime.getSeconds(),
      "q+": Math.floor((dateTime.getMonth() + 3) / 3),
      "S": dateTime.getMilliseconds() };

    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (dateTime.getFullYear() + "").substr(4 - RegExp.$1.length));
    }

    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }

    return fmt;
  },

  parseDate: function parseDate(text) {
    var dt = text.split(" "),
        hh = 0,
        mm = 0,
        ss = 0,
        matchD,
        year,
        month,
        dd,
        hmsStr,
        hms,
        ymdStr = dt[0];
    if (dt.length == 2) {
      hmsStr = dt[1];
    }

    if (matchD = ymdStr.match(/^(\d{4})\D(\d{1,2})\D(\d{1,2})$/)) {
      year = matchD[1];
      month = matchD[2];
      dd = matchD[3];
    } else {
      if (ymdStr.length === 8) {
        year = ymdStr.substring(0, 4);
        month = ymdStr.substring(4, 6);
        dd = ymdStr.substring(6, 8);
      }
    }
    if (hmsStr) {
      hms = hmsStr.match(/^(\d{2})\D(\d{2})\D(\d{2})/);
      hh = hms[1];
      mm = hms[2];
      ss = hms[3];
    }

    return new Date(year, month - 1, dd, hh, mm, ss);
  },

  getClientDate: function getClientDate(formate) {
    return this.formatDate(new Date(), formate || "yyyyMMdd");
  },

  getClientTime: function getClientTime(formate) {
    return this.formatDate(new Date(), formate || "hh:mm:ss");
  },

  getClientDateTime: function getClientDateTime(formate) {
    return this.formatDate(new Date(), formate || "yyyyMMdd hh:mm:ss");
  },

  getDifferDays: function getDifferDays(start, end) {
    var sDate = _.isString(start) ? this.parseDate(start) : start,
        eDate = _.isString(end) ? this.parseDate(end) : end,
        sTime = sDate.getTime(),
        eTime = eDate.getTime(),
        dMS = eTime - sTime;
    if (dMS === 0) {
      return 0;
    }
    if (dMS < 0) {
      return -1;
    }
    return Math.floor(dMS / (24 * 3600 * 1000));
  },

  getDifferMonths: function getDifferMonths(start, end) {
    var sDate = _.isString(start) ? this.parseDate(start) : start,
        eDate = _.isString(end) ? this.parseDate(end) : end,
        sTime = sDate.getTime(),
        eTime = eDate.getTime(),
        sYear,
        sMonth,
        sDay,
        eYear,
        eMonth,
        eDay,
        sMonthDays,
        eMonthDays;

    if (sTime === eTime) {
      return 0;
    }

    if (sTime > eTime) {
      return -1;
    }

    sYear = sDate.getFullYear();
    sMonth = sDate.getMonth() + 1;
    sDay = sDate.getDate();

    eYear = eDate.getFullYear();
    eMonth = eDate.getMonth() + 1;
    eDay = eDate.getDate();

    sMonthDays = this.getMonthDays(sYear, sMonth);
    eMonthDays = this.getMonthDays(eYear, eMonth);

    return eYear > sYear ? (eYear - sYear - 1) * 12 + (eMonth + (eDay >= sDay || eDay === eMonthDays && sDay <= sMonthDays ? 12 - sMonth : 12 - sMonth - 1)) : eMonth === sMonth ? 0 : eMonth - sMonth - (eDay >= sDay || eDay === eMonthDays && sDay <= sMonthDays ? 0 : 1);
  },

  getDifferYears: function getDifferYears(start, end, fixedNum) {
    var difMonths = this.getDifferMonths(start, end);
    if (fixedNum) {
      return difMonths >= 0 ? (difMonths / 12).toFixed(fixedNum) : -1;
    }
    return difMonths >= 0 ? parseInt(difMonths / 12) : -1;
  },

  isLeapYear: function isLeapYear(year) {
    return 0 === year % 4 && 0 !== year % 100 || 0 === year % 100 && 0 === year % 400;
  },

  getMonthDays: function getMonthDays(year, month) {
    return [undefined, 31, this.isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
  },

  compareDate: function compareDate(dateStr1, dateStr2) {
    var msec1 = this.parseDate(dateStr1).getTime(),
        msec2 = this.parseDate(dateStr2).getTime(),
        dif = msec1 - msec2;

    return dif > 0 ? 1 : dif < 0 ? -1 : 0;
  },

  isValidDate: function isValidDate(date) {
    return _.isDate(date) && !isNaN(date.getTime());
  },

  getDifDays: function getDifDays(date1, date2) {
    var time1 = (_.isDate(date1) ? date1 : this.parseDate(date1)).getTime(),
        time2 = (_.isDate(date2) ? date1 : this.parseDate(date2)).getTime();

    return parseInt((time2 - time1) / (24 * 60 * 60 * 1000));
  },

  addMonths: function addMonths(date, months) {
    date = this.parseDate(date);
    months = parseInt(months);

    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();

    for (var i = months; i > 0; i--) {
      month++;
      if (13 === month) {
        month = 1;
        year++;
      }
    }

    var monthDays = this.getMonthDays(year, month);
    if (monthDays < day) {
      day = monthDays;
    }

    function format(num) {
      if (num < 10) {
        return "0" + num;
      }
      return num + "";
    }

    return year + "" + format(month) + format(day);
  },

  addDays: function addDays(date, days, format) {
    var time = this.parseDate(date).getTime();
    return this.formatDate(new Date(time + parseInt(days) * 24 * 60 * 60 * 1000), format || "yyyyMMdd");
  },

  getDateBeforeToday: function getDateBeforeToday(days) {
    if (isNaN(days)) {
      return "";
    }
    var myDate = new Date(new Date().getTime() + days * 24 * 60 * 60 * 1000);
    var year = myDate.getFullYear() + "";
    var month = myDate.getMonth() + 1 > 9 ? (myDate.getMonth() + 1).toString() : '0' + (myDate.getMonth() + 1);
    var date = myDate.getDate() > 9 ? myDate.getDate().toString() : '0' + myDate.getDate();
    return year + month + date;
  }

};


//////////////////
// WEBPACK FOOTER
// ./src/tools/date.js
// module id = 69
// module chunks = 2